import ApiService from '../services/apiService.js'

function initialState (){
    return { 
        bookingInfo: {
            version: 1,
            currentStep: 1,
            general: {
                guid: '',
                reservationId: null,
                reservationGuids: [],
                bookingType: window.websiteSettings.defaultBookingType,
                pickupAddress: {
                    text: "",
                    location: null
                },
                isNotCoveredLocation: false,
                dropOffAddress: {
                    text: "",
                    location: null
                },
                pickupDate: null, // "29-09-2018", //null,
                pickupTime: null, //"16:10",//null,
                dropoffDate: null, // "29-09-2018", //null,
                dropoffTime: null, //"16:10",//null,
                needReturn: false,
                returnPickupDate: null, // "29-09-2018", //null,
                returnPickupTime: null, //"16:10",//null,
                numberOfCars: 1,
                bookingTip: 0,
                offer: null,
                durationInHours: 0,
                timeInMinutes: 0,
                distanceInMiles: 0,
                loadPricesFromServer: false, //next state update will request prices from server
                isPriceLoading: false,
                serverPriceErrors: []
            },
            selectedCar: {},
            payment: {
                paymentInProgress: false,
                errors: [],
                stripeThreeDSecureUrl: '',
                stripeThreeDSecureSourceId: '',  //server stripe source 3D secure != than initial one
                threeDSecureInProgress: false,
                done: false,
                stripeSource: {},
                stripeToken: null
            },
            passengerDetails: {
                salutation: '',
                email: '',
                phone: '',
                firstName: '',
                lastName: '',

                adultsNumber: '',
                childrenNumber: '',
                smallChildrenNumber: '',
                //driversNumber: 1,

                hasMeetAndGreet: false,

                largeLuggageNumber: '',
                mediumLuggageNumber: '',

                flightNumber: '',
                comingFrom: '',
                airline: null,
                roomNumber: '',
                driverInstructions: '',
                companyName: '',
                companyTaxNumber: '',
                companyAddress: '',
                companyAdditionalAddress: '',

                culture: '',

                arrivingByPlane: window.websiteSettings.bookingInfoArrivingByPlane,
                differentBilling: false,
                referredBy: null,
                carToDrive: null
            },
            mapInfo: {
                visible: true,
                from: null,
                to: null,
                type: 1,
                initialZoom: window.websiteSettings.mapInitialZoom,
                mapCenter: {
                    lat: window.websiteSettings.mapCenterLat,
                    lng: window.websiteSettings.mapCenterLng,
                }
            },
            availableCars: []
        },
        configuration: {
            apiKey: window.websiteSettings.apiKey,
            stripeId: window.websiteSettings.stripeId,
            paypalId: window.websiteSettings.paypalId,
            contactPhone: window.websiteSettings.contactPhone,
            country: window.websiteSettings.country,
            companyName: window.websiteSettings.companyName,
            companyTermsAndCondHtml: window.websiteSettings.companyTermsAndCondHtml,

            showCallOnTooClosePickup: window.websiteSettings.showCallOnTooClosePickup,
            showCallOnNotCoveredPickup: window.websiteSettings.showCallOnNotCoveredPickup,
            showSpecialOffersButton: window.websiteSettings.showSpecialOffersButton,
            defaultBookingType: window.websiteSettings.defaultBookingType, //1 is point to point, 2 is hourly 
            showBookingTypeSwitcher: window.websiteSettings.showBookingTypeSwitcher, //how hourly or transfer
            showReturnOption: window.websiteSettings.showReturnOption,

            useEndTimeInsteadOfBookingDuration: true,
            hideMeetAndGreet: window.websiteSettings.hideMeetAndGreet, 
            hidePassengers: window.websiteSettings.hidePassengers,
            hideFlightInfo: window.websiteSettings.hideFlightInfo,

            isDrivano: window.websiteSettings.isDrivano,
            
            saveCustomerCardForLaterCharges: false,
            percentageToChargeAtBookingTime: null,
            canConfirmByPhone: window.websiteSettings.canConfirmByPhone,
            canConfirmByCash: window.websiteSettings.canConfirmByCash,
            availableTips: [],
            bookingDurations: [
                { value: 0, text: "forms.booking.selectDurationPlaceholder" },
                //{ value: 1, text: "1 hour"},
              //  { value: 2, text: "2 hours" },
                { value: 3, text: "3 hours" },
                { value: 4, text: "4 hours" },
                { value: 5, text: "5 hours" },
                { value: 6, text: "6 hours" },
                { value: 7, text: "7 hours" },
                { value: 8, text: "8 hours" },
                { value: 9, text: "9 hours" },
                { value: 10, text: "10 hours" },
                { value: 11, text: "11 hours" },
                { value: 12, text: "12 hours" }
                //{ value: 13, text: "13 hours" },
                //{ value: 14, text: "14 hours" },
                //{ value: 15, text: "15 hours" },
                //{ value: 16, text: "16 hours" },
                //{ value: 17, text: "17 hours" },
                //{ value: 18, text: "18 hours" },
                //{ value: 19, text: "19 hours" },
                //{ value: 20, text: "20 hours" },
                //{ value: 21, text: "21 hours" },
                //{ value: 22, text: "22 hours" },
                //{ value: 23, text: "23 hours" },
                //{ value: 24, text: "24 hours" }
            ]
        }
    }
}

const bookingModule = {
    namespaced: true,
    state: initialState(),
    mutations: {
        setInitialState: function(state) {
            console.log('test test', state);
            state.bookingInfo = initialState().bookingInfo;            
        },
        setBookingGuid: function(state, data) {
            state.bookingInfo.general.guid = data;
        },
        setBookingHash: function(state, data) {
            state.bookingInfo.general.hash = data;
        },
        setReservationId: function(state, data) {
            state.bookingInfo.general.reservationId = data;
        },
        setReservationGuids: function(state, data) {
            state.bookingInfo.general.reservationGuids = data;
        },
        setBookingType: (state, data) => {
            console.log('booking type', data);
            state.bookingInfo.general.bookingType = data;
            state.bookingInfo.mapInfo = Object.assign({}, state.bookingInfo.mapInfo, { type: data });
        },
        setCurrentStep: (state, data) => {
            state.bookingInfo.currentStep = data;
        },
        setPickupLocation: (state, data) => {
            state.bookingInfo.general.pickupAddress.text = data.text;
            state.bookingInfo.general.pickupAddress.location = data.location;
            state.bookingInfo.mapInfo.from = data.location.latLng;
            state.bookingInfo.mapInfo = Object.assign({}, state.bookingInfo.mapInfo, { from: data.location });
        },
        setDropoffLocation: (state, data) => {
            state.bookingInfo.general.dropOffAddress.text = data.text;
            state.bookingInfo.general.dropOffAddress.location = data.location;
            state.bookingInfo.mapInfo.to = data.location.latLng;
            state.bookingInfo.mapInfo = Object.assign({}, state.bookingInfo.mapInfo, { to: data.location });
        },
        setPickupDate: (state, data) => {
            state.bookingInfo.general.pickupDate = data;
        },
        setPickupTime: (state, data) => {
            state.bookingInfo.general.pickupTime = data;
        },
        setDropoffDate: (state, data) => {
            state.bookingInfo.general.dropoffDate = data;
        },
        setDropoffTime: (state, data) => {
            state.bookingInfo.general.dropoffTime = data;
        },
        setNeedReturn:  (state, data) => {
            state.bookingInfo.general.needReturn = data;
        },
        setReturnPickupDate: (state, data) => {
            state.bookingInfo.general.returnPickupDate = data;
        },
        setReturnPickupTime: (state, data) => {
            state.bookingInfo.general.returnPickupTime = data;
        },
        //for transfer bookings set duration when price is checked
        setTimeInMinutes: (state, data) => {
            state.bookingInfo.general.timeInMinutes = data;
        },
        setDurationInHours: (state, data) => {
            state.bookingInfo.general.durationInHours = data;
        },
        setNumberOfCars: (state, numberOfCars) => {
            state.bookingInfo.general.numberOfCars = numberOfCars;
        },
        setOffer: (state, offer) => {
            state.bookingInfo.general.offer = offer;
        },
        setAvailableCars: (state, carsWithPrices) =>{
            console.log('item');
            state.bookingInfo.availableCars.length = 0;
            carsWithPrices.forEach(function (item) {
                state.bookingInfo.availableCars.push(item);
                //if current item is the selected one, update selected item to reflect price change
                if (state.bookingInfo.selectedCar && state.bookingInfo.selectedCar.guid === item.guid) {
                    state.bookingInfo.selectedCar = item;
                    console.log('item');
                    if(item.numberOfCars)
                        //this.setNumberOfCars(state,  item.numberOfCars);
                        state.bookingInfo.general.numberOfCars = item.numberOfCars;
                }
            });
        },
        setSelectedCar: function(state, data) {
            state.bookingInfo.selectedCar = data;
            if(data.numberOfCars)
                state.bookingInfo.general.numberOfCars = data.numberOfCars;
            //if (data) state.bookingInfo.currentStep = 3;
        }, 
        setPassengerLanguage: function(state, data){
            console.log("passenger language", data)
            state.bookingInfo.passengerDetails.culture = data;
        },
        setPassengerDetailsProperty: function (state, data) {
            var name = data.propertyName;
            state.bookingInfo.passengerDetails[name] = data.value;
        },
        setNotCoveredLocation: function(state, data) {
            state.bookingInfo.general.isNotCoveredLocation = data;
        },
        setBookingTip: function(state, data){
            state.bookingInfo.general.bookingTip = data;
        },
        setWebsiteConfiguration: function (state, data) {
            state.configuration.stripeId = data.stripeKey;
            state.configuration.country = data.country;
            state.configuration.percentageToChargeAtBookingTime = data.percentageToChargeAtBookingTime;
            state.configuration.saveCustomerCardForLaterCharges = data.saveCustomerCardForLaterCharges;
            state.configuration.canConfirmByPhone = data.canConfirmByPhone;
            state.configuration.canConfirmByCash = data.canConfirmByCash;
            state.configuration.arrivingByPlane = data.arrivingByPlaneDefaultValue;
            if(data.availableTips){
                state.configuration.availableTips = data.availableTips; 
                if(!state.bookingInfo.general.bookingTip){
                    let checked = data.availableTips.find(el=>el.checked);
                    if(checked) state.bookingInfo.general.bookingTip = checked.id;
                }
            }
            else {
                state.configuration.availableTips = [];
                state.bookingInfo.general.bookingTip = 0;
            }
        }
    },
    actions: {
        resetBooking: function(store) {
            //console.log('test test');
            store.state = initialState();
        },
        updateConfiguration: function (store) {
            ApiService.getWebsiteSettings(store.state.configuration.apiKey).then((response) => {
                if (!response.data.success) { return; }

                store.commit('setWebsiteConfiguration', response.data.result);
            }).catch(error => {
                console.log("updateConfiguration call failed", error);
            });
        },
        getBookingPrice: function (store) {
            var promise =  new Promise((resolve, reject) => {
                var bookingInfo = store.state.bookingInfo.general;
                var passengerDetails = {};
                passengerDetails.childrenNumber = store.state.bookingInfo.passengerDetails.childrenNumber;
                passengerDetails.hasMeetAndGreet = store.state.bookingInfo.passengerDetails.hasMeetAndGreet;
                passengerDetails.offer = store.state.bookingInfo.general.offer;
                var bookingInfoModel = {
                        apiKey: store.state.configuration.apiKey,
                        carTypeGuid: null, //carTypeId: this.bookingInfoModel.carTypeId, //"1",
                        type: bookingInfo.bookingType,
                        from: bookingInfo.pickupAddress.location,
                        to: bookingInfo.bookingType === 1 ? bookingInfo.dropOffAddress.location : null,
                        durationInHours: bookingInfo.durationInHours,
                        numberOfCars: bookingInfo.numberOfCars,
                        bookingTip: bookingInfo.bookingTip,
                        pickupDateTime: bookingInfo.pickupDate + " " + bookingInfo.pickupTime,
                        pickupDateDisplayed: bookingInfo.pickupDate + " " + bookingInfo.pickupTime,
                        promoCode: bookingInfo.promoCode,
                        passengerDetails: passengerDetails
                };
                if(bookingInfo.needReturn) {
                    bookingInfoModel.needReturn = bookingInfo.needReturn;
                    bookingInfoModel.returnPickupDateTime = bookingInfo.returnPickupDate + " " + bookingInfo.returnPickupTime;
                    bookingInfoModel.returnPickupDateDisplayed = bookingInfo.returnPickupDate + " " + bookingInfo.returnPickupTime;
                }
                
                //dropoff date time for hourly bookings
                if(bookingInfo.dropoffDate && bookingInfo.dropoffTime) {
                    bookingInfoModel.dropoffDateTime = bookingInfo.dropoffDate + " " + bookingInfo.dropoffTime;
                }
                
                ApiService.getTripPriceForAllCar(bookingInfoModel).then((response) => {
                    //console.log('server response', response );
                    if (!response.data.success) {
                        //store.commit('setPriceLoading', false);
                        //store.commit('setServerPriceErrors', response.data.errors);
                        if (response.data.result && response.data.result.isNotCovered) {
                            store.commit('setNotCoveredLocation', response.data.result.isNotCovered);
                        }
                        reject(response.data.errors);
                        return;
                    }
                    store.commit('setNotCoveredLocation', false);
                    store.commit('setAvailableCars', response.data.result.cars);                    
                    if(response.data.result.durationInMinutes)
                        store.commit('setTimeInMinutes', Math.ceil(response.data.result.durationInMinutes));
                    
                    resolve(response.data.result.cars);
                }).catch((/*error*/) => {
                    //console.log("call failed", error);
                    //store.commit('setPriceLoading', false);
                    //store.commit('setServerPriceErrors', ["We could not load available cars for your trip. Please try again."]);
                    reject(["We could not load available cars for your trip. Please try again."]);
                });
            });

           return promise;
        },
        updateBookingPrice: function (store) {
            console.log('testtest');
            var promise =  new Promise((resolve, reject) => {
                var bookingInfo = store.state.bookingInfo.general;
                var passengerDetails = {};
                passengerDetails.adultsNumber = store.state.bookingInfo.passengerDetails.adultsNumber;
                passengerDetails.childrenNumber = store.state.bookingInfo.passengerDetails.childrenNumber;
                passengerDetails.hasMeetAndGreet = store.state.bookingInfo.passengerDetails.hasMeetAndGreet;
                passengerDetails.offer = store.state.bookingInfo.general.offer;
                var bookingInfoModel = {
                    apiKey: store.state.configuration.apiKey,
                    //carTypeGuid: null, //NOTE: -> we need to update all cars prices
                    type: bookingInfo.bookingType,
                    from: bookingInfo.pickupAddress.location,
                    to: bookingInfo.bookingType === 1 ? bookingInfo.dropOffAddress.location : null,
                    durationInHours: bookingInfo.durationInHours,
                    numberOfCars: bookingInfo.numberOfCars,
                    bookingTip: bookingInfo.bookingTip,
                    pickupDateTime: bookingInfo.pickupDate + " " + bookingInfo.pickupTime,
                    pickupDateDisplayed: bookingInfo.pickupDate + " " + bookingInfo.pickupTime,
                    promoCode: bookingInfo.promoCode,
                    passengerDetails: passengerDetails
                };

                if(bookingInfo.needReturn) {
                    bookingInfoModel.needReturn = bookingInfo.needReturn;
                    bookingInfoModel.returnPickupDateTime = bookingInfo.returnPickupDate + " " + bookingInfo.returnPickupTime;
                    bookingInfoModel.returnPickupDateDisplayed = bookingInfo.returnPickupDate + " " + bookingInfo.returnPickupTime;
                }
                //dropoff date time for hourly bookings
                if(bookingInfo.dropoffDate && bookingInfo.dropoffTime) {
                    bookingInfoModel.dropoffDateTime = bookingInfo.dropoffDate + " " + bookingInfo.dropoffTime;
                }
                ApiService.getTripPriceForAllCar(bookingInfoModel).then((response) => {
                    //if we have error -> set that TODO: redirect to step 1
                    if (!response.data.success) {
                        if (response.data.result && response.data.result.isNotCovered) {
                            store.commit('setNotCoveredLocation', response.data.result.isNotCovered);
                        }
                        reject(response.data.errors);
                        return;
                    }

                    //price was loaded successfully ->update available car list 
                    store.commit('setNotCoveredLocation', false);
                    store.commit('setAvailableCars', response.data.result.cars);
                    if(response.data.result.durationInMinutes)
                        store.commit('setTimeInMinutes', Math.ceil(response.data.result.durationInMinutes));

                    resolve(response.data.result.cars);
                }).catch((/*error*/) => {
                    reject(["We could not load available cars for your trip. Please try again."]);
                });
            });
            return promise;
        },
        setupCardPayment: function(store){
            var promise =  new Promise((resolve, reject) => {
                ApiService.setupCardPayment(store.state.configuration.apiKey).then((response) => {
                    if (!response.data.success) {                       
                        reject(response.data.errors);
                        return;
                    }
                    
                    resolve(response.data.result);
                }).catch((/*error*/) => {
                    reject(["We could not initialize card payment provider. Please try again."]);
                });
            });
            return promise;
        },
        getReservationDetails(context, guid) {
            let token = context.state.token;
            return new Promise((resolve, reject) => {
              ApiService.getReservationDetails(guid, token)
              .then(result => {
                if(result.data.success){
                  console.log('getReservationDetails action called with success')
                  //update user account in store
                  resolve(result.data.result);
                }
                else{
                  console.log('getReservationDetails action called with errors')
                  reject(result.data.errors);
                }
              })
              .catch(err => {
                console.log('getReservationDetails action has error', err);
                if(err.response.status == 401){
                  context.dispatch('logout');              
                }
                reject(['Could not read user profile. An error occured.']);
              });
            });
        },
        getReservationCancellationInfo(context, hash) {
            let token = context.state.token;
            return new Promise((resolve, reject) => {
              ApiService.getReservationCancellationInfo(hash, token)
              .then(result => {
                if(result.data.success){
                  console.log('getReservationCancellationInfo action called with success', result.data.result)
                  //update user account in store
                  resolve(result.data.result);
                }
                else{
                  console.log('getReservationCancellationInfo action called with errors')
                  reject(result.data.errors);
                }
              })
              .catch(err => {
                console.log('getReservationCancellationInfo action has error', err);
                if(err.response.status == 401){
                  context.dispatch('logout');              
                }
                reject(['Could not read user profile. An error occured.']);
              });
            });
        },
        cancelReservation(context, cancellationInfo) {
            let token = context.state.token;
            return new Promise((resolve, reject) => {
              ApiService.cancelReservation(cancellationInfo, token)
              .then(result => {
                if(result.data.success){
                  console.log('cancelReservation action called with success')
                  resolve(result.data);
                }
                else{
                  console.log('cancelReservation action called with errors')
                  reject(result.data.errors);
                }
              })
              .catch(err => {
                console.log('cancelReservation action has error', err);
                if(err.response.status == 401){
                  context.dispatch('logout');              
                }
                reject(['Could not read user profile. An error occured.']);
              });
            });
        }
      },
    getters: {
        currentStep: (state) => {
            return state.bookingInfo.currentStep;
        },
        showBookingTypeSwitcher: (state)=>{
            return state.configuration.showBookingTypeSwitcher;
        },
        showReturnOption: (state)=>{
            return state.configuration.showReturnOption;
        },
        isHourlyBooking: (state) => {
            return state.bookingInfo.general.bookingType === 2;
        },
        mapInfo: (state) =>{
            return state.bookingInfo.mapInfo;
        },
        timeInMinutes: (state) => {
            return state.bookingInfo.general.timeInMinutes;
        }
      }
  }

export default bookingModule;